import TSvgProps from 'svgIcons/type/svgPropsType'

const AnalysisIcon = (props: TSvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...props}
    >
      <desc>기업분석자료 아이콘</desc>
      <path fill="none" d="M0 0h20v20H0z" data-name="사각형 34605"></path>
      <g data-name="그룹 50898">
        <path
          fill="#01a0ff"
          d="M5.056 2.445h8.572a.4.4 0 0 1 .276.157l2.238 2.918a.43.43 0 0 1 .114.271l-.031 10.451a1.314 1.314 0 0 1-1.314 1.314H5.056a1.314 1.314 0 0 1-1.314-1.311V3.758a1.314 1.314 0 0 1 1.314-1.313"
          data-name="패스 16135"
        ></path>
        <g fill="#fff" data-name="그룹 47279">
          <path
            d="M9.677 7.097a3.2 3.2 0 1 0 3.2 3.2q-.002-.075-.008-.149H9.677z"
            data-name="패스 16133"
          ></path>
          <path
            d="M10.567 6.501v2.826h2.957a2.965 2.965 0 0 0-2.957-2.826"
            data-name="패스 16134"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default AnalysisIcon
